import localeba2612ee from '../../locales/ja.json'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
}
export const nuxtOptions = {
  isUniversalMode: false,
  trailingSlash: true,
}
export const options = {
  vueI18n: {"fallbackLocale":"ja"},
  vueI18nLoader: true,
  locales: [{"code":"ja","name":"日本語","iso":"ja_JP","file":"ja.json"},{"code":"en","name":"English","iso":"en_US","file":"en.json"},{"code":"zh","name":"中文","iso":"zh_CN","file":"zh.json"}],
  defaultLocale: "ja",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "no_prefix",
  lazy: true,
  langDir: "/home/runner/work/spdm_cus/spdm_cus/locales",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","onlyOnNoPrefix":false,"onlyOnRoot":false,"useCookie":true},
  differentDomains: false,
  seo: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncLocale":false,"syncMessages":false,"syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  beforeLanguageSwitch: () => null,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"ja","name":"日本語","iso":"ja_JP","file":"ja.json"},{"code":"en","name":"English","iso":"en_US","file":"en.json"},{"code":"zh","name":"中文","iso":"zh_CN","file":"zh.json"}],
  localeCodes: ["ja","en","zh"],
}

export const localeMessages = {
  'ja.json': () => Promise.resolve(localeba2612ee),
  'en.json': () => import('../../locales/en.json' /* webpackChunkName: "lang-en.json" */),
  'zh.json': () => import('../../locales/zh.json' /* webpackChunkName: "lang-zh.json" */),
}
